import { Component } from "react";
import Window from "../ui/Window";
import { AiOutlineDashboard } from "react-icons/ai";
import { BsFillCheckCircleFill, BsSignStop, BsSignStopFill } from "react-icons/bs";
import BasicDataGrid from "../ui/BasicDataGrid";
import { Stack } from "@mui/system";
import { Box, Chip, Drawer, Typography } from "@mui/material";
import { PieChart } from '@mui/x-charts/PieChart';
import UnidadeSelect from "../ui/UnidadeSelect";
import { MdMoving, MdOutlineTimer, MdPhoneAndroid } from "react-icons/md";
import DashLabel from "../ui/DashLabel";
import DepositoFicha from "./DepositoFicha";
import { httpGet } from "../util/http";
import { INVENTARIO_CONCLUIDO } from "../util/contants";
import DashStatus from "../ui/DashStatus";
import Cookies from "universal-cookie";

export default class Dashboard extends Component {

    constructor(props) {
        super(props);
        let cookies = new Cookies();
        this.user = cookies.get('user');
        this.state = {
            loading: false,
            showDepFicha: false,
            showUnidFicha: false,
            unidades: [],
            currDeposito: null,
            statsKey: new Date().valueOf(),//uma chave pra forçar o componente DashStatus reatualizar.
        };

        this.columns = [
            { field: 'unidade', headerName: 'Unidade', minWidth: 300, valueGetter: (params) => params.row?.nome },
            { field: 'depositos', headerName: 'Status dos depósitos', flex: 1, minWidth: 200, renderCell: (params) => this.statusDepositos(params.row?.depositos) },
        ];
    }

    statusDepositos(depositos) {
        return <Stack gap={1} direction="row">
            {depositos?.map((deposito, i) =>
                <Chip key={"dep" + i} onClick={e => this.onDepFichaClick(e, deposito)} color={deposito.status == INVENTARIO_CONCLUIDO ? "success" : "error"} label={deposito.nome} icon={deposito.status != INVENTARIO_CONCLUIDO ? <BsSignStopFill size={19} /> : <></>} />
            )}

            {/* // <Chip color="success" label="Depósito 100" />
            // <Chip label="Depósito 100" /> */}
        </Stack>
    }

    onDepFichaClick(e, deposito) {
        e.stopPropagation();
        this.setState({ showDepFicha: true, currDeposito: deposito });
    }

    componentDidMount() {
        this.refresh(false);
    }

    refresh(statsRefresh) {
        this.setState({ loading: true });
        httpGet('/unidades/list',
            unidades => {
                //console.log(unidades)
                if (statsRefresh) {
                    this.setState({
                        unidades,
                        loading: false,
                        statsKey: new Date().valueOf()
                    });
                } else {
                    this.setState({
                        unidades,
                        loading: false,
                    });
                }
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
            false
        );
    }

    render() {
        return (
            <Window full title="Dashboard" icon={AiOutlineDashboard}>
                {this.state.showDepFicha && <DepositoFicha onRefresh={() => this.refresh(true)} deposito={this.state.currDeposito} onClose={e => this.setState({ showDepFicha: false })} />}
                <Stack mt={2} mb={1} gap={1}>
                    {this.user.isAdmin &&
                        <>
                            {/* <Stack direction="row" gap={1}>
                                <UnidadeSelect sx={{ width: 300 }} />
                            </Stack> */}
                            <DashStatus key={this.state.statsKey} />
                        </>}
                </Stack>
                <BasicDataGrid
                    props={{
                        loading: this.state.loading
                    }} rows={this.state.unidades} columns={this.columns} />
            </Window>
        );
    }
}
